import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')

// Add error logging to help debug tablet issues
window.addEventListener('error', function(e) {
  console.error('Global error caught:', e.message, e.filename, e.lineno, e.colno, e.error);
  
  // Create a visible error message for debugging on tablet
  if (!document.getElementById('error-debug')) {
    const errorDiv = document.createElement('div');
    errorDiv.id = 'error-debug';
    errorDiv.style.position = 'fixed';
    errorDiv.style.bottom = '0';
    errorDiv.style.left = '0';
    errorDiv.style.right = '0';
    errorDiv.style.background = 'rgba(255,0,0,0.7)';
    errorDiv.style.color = 'white';
    errorDiv.style.padding = '10px';
    errorDiv.style.zIndex = '9999';
    errorDiv.style.fontSize = '12px';
    errorDiv.style.maxHeight = '30%';
    errorDiv.style.overflow = 'auto';
    document.body.appendChild(errorDiv);
  }
  
  document.getElementById('error-debug').innerHTML += `<p>${e.message} at ${e.filename}:${e.lineno}</p>`;
});

// Check if the app is actually mounting
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, checking if Vue app mounted...');
  
  // Give Vue a moment to mount
  setTimeout(() => {
    if (document.getElementById('app').childElementCount === 0) {
      console.error('Vue app failed to mount!');
      document.getElementById('app').innerHTML = '<div style="padding: 20px; text-align: center;">App failed to load. Please try refreshing the page.</div>';
    } else {
      console.log('Vue app mounted successfully');
    }
  }, 2000);
});

// Create a unified device detection utility
window.deviceUtils = {
  // Store device state
  state: {
    isMobile: false,
    isTablet: false,
    isIPad: false,
    isLandscape: false,
    width: window.innerWidth,
    height: window.innerHeight
  },
  
  // Initialize detection
  init() {
    const userAgent = navigator.userAgent;
    
    // Detect iPad
    this.state.isIPad = /iPad/i.test(userAgent) || 
                        (/Macintosh/i.test(userAgent) && 'ontouchend' in document && 
                        navigator.maxTouchPoints > 1);
    
    // Update all states
    this.updateState();
    
    // Add resize listener
    window.addEventListener('resize', () => this.updateState());
    window.addEventListener('orientationchange', () => this.updateState());
    
    console.log('Device detection initialized:', this.state);
    
    return this.state;
  },
  
  // Update all device state properties
  updateState() {
    this.state.width = window.innerWidth;
    this.state.height = window.innerHeight;
    this.state.isMobile = window.innerWidth <= 600;
    this.state.isTablet = (window.innerWidth > 600 && window.innerWidth <= 1024) || this.state.isIPad;
    this.state.isLandscape = window.innerWidth > window.innerHeight;
    
    // Dispatch a custom event that components can listen for
    window.dispatchEvent(new CustomEvent('devicechange', { detail: this.state }));
    
    return this.state;
  },
  
  // Helper methods
  isMobile() { return this.state.isMobile; },
  isTablet() { return this.state.isTablet; },
  isDesktop() { return !this.state.isMobile && !this.state.isTablet; },
  isLandscape() { return this.state.isLandscape; }
};

// Initialize device detection when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Initialize the device utilities
  window.deviceUtils.init();
  
  // Apply iPad-specific fixes (keeping existing code)
  if (window.deviceUtils.state.isIPad) {
    console.log('Real iPad detected, applying specific fixes');
    
    // Fix 1: Force layout recalculation
    document.body.style.display = 'none';
    document.body.offsetHeight; // Force reflow
    document.body.style.display = 'block';
    
    // Fix 2: Ensure Vue has time to mount properly
    let attempts = 0;
    const checkMount = setInterval(() => {
      attempts++;
      const app = document.getElementById('app');
      
      if (app && app.childElementCount > 0) {
        console.log('Vue mounted successfully after ' + attempts + ' attempts');
        clearInterval(checkMount);
      } else if (attempts >= 10) {
        console.log('Vue mount timeout, forcing recovery');
        clearInterval(checkMount);
        
        // Fix 3: Try to recover by injecting content directly
        const app = document.getElementById('app');
        if (app && app.childElementCount === 0) {
          app.innerHTML = `
            <div style="padding: 20px; text-align: center;">
              <h2>Loading 2-1-7...</h2>
              <p>If content doesn't appear, please <a href="javascript:window.location.reload(true)">refresh the page</a>.</p>
            </div>
          `;
          
          // Fix 4: Force reload after a delay as last resort
          setTimeout(() => {
            if (document.querySelectorAll('#app .blog-post, #app .model-content, #app .about-content').length === 0) {
              console.log('No content detected, forcing reload');
              window.location.reload(true);
            }
          }, 5000);
        }
      }
    }, 500);
    
    // Fix 5: Add iPad-specific CSS fixes
    const style = document.createElement('style');
    style.textContent = `
      /* iPad-specific fixes */
      @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
        body, html, #app {
          height: 100% !important;
          width: 100% !important;
          overflow-x: hidden !important;
          -webkit-overflow-scrolling: touch !important;
        }
        
        * {
          -webkit-backface-visibility: hidden;
          -webkit-transform: translate3d(0,0,0);
        }
      }
    `;
    document.head.appendChild(style);
  }
});
